(function() {
    'use strict';
    angular
        .module('ipmApp')
        .factory('Battery', Battery);

    Battery.$inject = ['$resource'];

    function Battery ($resource) {
        var resourceUrl =  'api/batteries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
